import React from 'react';
import styled from 'styled-components';
import { CloseButton } from '../../button';
import { theme } from '../../../theme';
import { UploadProgressBar } from '../../uploadProgressBar';

type CardProps = {
  imageUrl: string;
  isVideo?: boolean;
};

const Card = styled.div<CardProps>`
  display: flex;
  width: ${({ isVideo }) => (isVideo ? 188 : 100)}px;
  height: 100px;
  background-image: url('${({ imageUrl }) => imageUrl}');
  border-radius: ${theme.borderRadius.small};
  position: relative;
  overflow: hidden;
`;

const CloseButtonContainer = styled.div`
  margin: 4px 4px auto auto;
`;

export type MediaCardProps = CardProps & {
  id: string;
  percentUploaded: number;
  onRemove: (id: string) => void;
};

export const MediaCard: React.FC<MediaCardProps> = ({
  id,
  imageUrl,
  isVideo = false,
  percentUploaded,
  onRemove,
}) => (
  <Card imageUrl={imageUrl} isVideo={isVideo}>
    <CloseButtonContainer>
      <CloseButton onClick={() => onRemove(id)} />
    </CloseButtonContainer>
    {!!percentUploaded && percentUploaded < 100 && (
      <UploadProgressBar progress={percentUploaded} />
    )}
  </Card>
);
